// functions/client/js/common/urlValidation.ts
import {
  isSafeRedirectUrlInternal
} from '../../../src/utils/urlHelper';

/**
 * URLクエリパラメータを取得するユーティリティ
 */
export function getUrlVars(): Record<string, string | null> {
  const vars: Record<string, string | null> = {};
  const params = new URLSearchParams(document.location.search.substring(1));
  vars["url"] = params.get("url");
  return vars;
}

/**
 * ホスト名を大文字小文字・末尾ドット(FQDN表記)の差異を無視して比較できる形に正規化する。
 */
function normalizeHost(host: string): string {
  return host.toLowerCase().replace(/\.$/, '');
}

/**
 * リダイレクト先URLが安全かどうかを判定するユーティリティ (ブラウザ用)
 */
export function isSafeRedirectUrl(url: string | null | undefined): boolean {
  return isSafeRedirectUrlInternal(url, (hostname, protocol) => {
    if (typeof window === 'undefined') {
      return false;
    }

    const currentHost = normalizeHost(window.location.hostname);
    const targetHost = normalizeHost(hostname);

    // HTTPS -> http へのダウングレードを防止
    if (window.location.protocol === 'https:' && protocol === 'http:') {
      return false;
    }

    // 同一ホスト名のチェック (従来の動作)
    if (targetHost === currentHost) {
      return protocol === "http:" || protocol === "https:";
    }

    // Firebase Hosting では同一プロジェクトに *.web.app と *.firebaseapp.com の2つのドメインが存在する
    const firebaseSuffix = '.firebaseapp.com';
    const webSuffix = '.web.app';
    if (
      (currentHost.endsWith(firebaseSuffix) || currentHost.endsWith(webSuffix)) &&
      (targetHost.endsWith(firebaseSuffix) || targetHost.endsWith(webSuffix))
    ) {
      const getProjectId = (host: string) => {
        if (host.endsWith(firebaseSuffix)) {
          return host.slice(0, -firebaseSuffix.length);
        }
        if (host.endsWith(webSuffix)) {
          return host.slice(0, -webSuffix.length);
        }
        return host;
      };

      const currentProjectId = getProjectId(currentHost);
      const targetProjectId = getProjectId(targetHost);
      if (currentProjectId === targetProjectId) {
        return protocol === "http:" || protocol === "https:";
      }
    }

    return false;
  });
}
